import React from "react";
import { Route, Switch } from "react-router";
import { useGlobalContext } from "../../context/global.context";
import CommonRedirectPage from "../../../commonRedirectPage/CommonRedirectPage";
import Spinner from "../Spinner";
import { PrivateRoutes, locationIncludes } from "../../models/routes";
import Home from "../../../Home/Home";

interface Props {
  children: JSX.Element[] | JSX.Element;
}

function ProtectedRoute({ children }: Props) {
  const { allowedRoutes } = useGlobalContext();

  if (allowedRoutes.length == 0) {
    return (
      <Spinner />
    );
  }

  if (allowedRoutes.some((r: { url: any; }) => locationIncludes(r.url))) {
    return (
      <Switch>
        {children}
        <Route 
        path="/unauth" 
        component={() => <CommonRedirectPage text="No estas autorizado a consultar esta pagina"/>} 
      />
      <Route path="/*" component={() => <CommonRedirectPage />} />
      </Switch>
    );
  }

  return (
    <Switch>
      <Route exact path={PrivateRoutes.HOME} component={Home} />
      <Route 
        path="/unauth" 
        component={() => <CommonRedirectPage text="No estas autorizado a consultar esta pagina"/>} 
      />
      <Route path="/*" component={() => <CommonRedirectPage />} />
    </Switch>
  );
}
export default ProtectedRoute;